import Swiper from "swiper";
import { Navigation, Autoplay } from "swiper/modules";

var swiper = new Swiper(".swiper-insights", {
  slidesPerView: 1,
  modules: [Navigation, Autoplay],
  spaceBetween: 40,
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
  autoplay: {
    delay: 2500,
  },
  loop: true,
  breakpoints: {
    0: {
      slidesPerView: 1,
      spaceBetween: 10,
    },
    700: {
      slidesPerView: 1,
    },
  },
});
